module.exports = __webpack_public_path__ + "01_medium_gold.252619b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/dad/layer5/01_medium_gold.png
// module id = jHL7
// module chunks = 0